import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AuthService } from '@app/@core/services/auth.service';
import { AppConstants } from '@core/entities/app-constants';
import { AlertService } from '@core/services/alert.service';

@Component({
  selector: 'app-switch-role',
  templateUrl: './switch-role.component.html',
  styleUrl: './switch-role.component.scss',
  standalone: false,
})
export class SwitchRoleComponent implements OnInit {
  @Input() showSwitchRoleModal: boolean = false;
  @Output() closeModal = new EventEmitter<void>();

  userRole: any;
  currentUser: any;
  switchRoleList: any[] = [];
  selectedRole: string | null = null;
  isConfirm: boolean = false;
  isSwitchRole: boolean = false;
  roleChangeMsg: string = '';

  constructor(
    private authService: AuthService,
    private alertService: AlertService
  ) {
    this.userRole = JSON.parse(sessionStorage.getItem('userrole') || '{}');
    this.currentUser = JSON.parse(sessionStorage.getItem('user') || '{}');
  }

  ngOnInit(): void {
    this.buildSwitchRoleList();
  }

  private buildSwitchRoleList(): void {
    const userRoleSession = this.userRole?.userrolesession;
    const roleId = JSON.parse(sessionStorage.getItem('role_id'));
    this.switchRoleList =
      this.userRole?.userroles
        ?.filter((role: any) => !(role?.id === userRoleSession?.roleId || role?.id === roleId))
        ?.map((role: any) => ({
          roleName: role?.roledesc,
          roleCd: role?.name,
          id: role?.id,
        }))
      || [];
  }

  onSwitchRoleChange(value: string): void {
    const selected = this.switchRoleList.find(r => r.roleCd === value);
    this.selectedRole = value;
    this.isSwitchRole = !!selected;
    this.isConfirm = this.isSwitchRole;
    this.roleChangeMsg = selected
      ? `Are you sure you want to Login as a <i>${selected.roleName}</i> ?`
      : '';
  }

  onSwitchRoleClose(): void {
    this.closeModal.emit();
    this.isConfirm = false;
    this.isSwitchRole = false;
    this.selectedRole = null;
    this.roleChangeMsg = '';
  }

  onConfirmSwitchRole(): void {
    
    const currentRole = this.userRole?.userroles?.find((role: any) => role?.isprimary);
    const selectedRole = this.switchRoleList.find(r => r.roleCd === this.selectedRole);

    if (!this.currentUser?.id || !currentRole?.id || !selectedRole) {
      this.alertService.error(AppConstants.errorMessage);
      return;
    }

    const userRoleHistoryPayload = {
      userId: this.currentUser.id,
      previousRoleId: currentRole.id,
      previousRoleName: currentRole.name,
      roleId: selectedRole.id,
      roleName: selectedRole.roleCd,
    };

    this.authService.saveUserSessionRoleHistory(userRoleHistoryPayload).subscribe({
      next: (res: any) => {
        if (res) {
          this.authService.getUserRoleChange(selectedRole.id, selectedRole.roleCd);
          this.onSwitchRoleClose();
        }
      },
      error: err => {
        console.log(err.name);
        this.alertService.error(AppConstants.errorMessage);
      },
    });
  }
}
